export const prefixes: any = [
    {prefix: "+1", stateCode: "US"},
    {prefix: "+1", stateCode: "CA"},
    {prefix: "+7", stateCode: "RU"},
    {prefix: "+27", stateCode: "ZA"},
    {prefix: "+30", stateCode: "GR"},
    {prefix: "+31", stateCode: "NL"},
    {prefix: "+32", stateCode: "BE"},
    {prefix: "+33", stateCode: "FR"},
    {prefix: "+34", stateCode: "ES"},
    {prefix: "+36", stateCode: "HU"},
    {prefix: "+39", stateCode: "IT"},
    {prefix: "+39", stateCode: "VA"},
    {prefix: "+40", stateCode: "RO"},
    {prefix: "+41", stateCode: "CH"},
    {prefix: "+43", stateCode: "AT"},
    {prefix: "+44", stateCode: "GB"},
    {prefix: "+45", stateCode: "DK"},
    {prefix: "+46", stateCode: "SE"},
    {prefix: "+47", stateCode: "NO"},
    {prefix: "+48", stateCode: "PL"},
    {prefix: "+49", stateCode: "DE"},
    {prefix: "+52", stateCode: "MX"},
    {prefix: "+55", stateCode: "BR"},
    {prefix: "+60", stateCode: "MY"},
    {prefix: "+61", stateCode: "AU"},
    {prefix: "+61", stateCode: "CC"},
    {prefix: "+61", stateCode: "CX"},
    {prefix: "+64", stateCode: "NZ"},
    {prefix: "+64", stateCode: "PN"},
    {prefix: "+81", stateCode: "JP"},
    {prefix: "+86", stateCode: "CN"},
    {prefix: "+90", stateCode: "TR"},
    {prefix: "+350", stateCode: "GI"},
    {prefix: "+351", stateCode: "PT"},
    {prefix: "+352", stateCode: "LU"},
    {prefix: "+353", stateCode: "IE"},
    {prefix: "+354", stateCode: "IS"},
    {prefix: "+355", stateCode: "AL"},
    {prefix: "+356", stateCode: "MT"},
    {prefix: "+357", stateCode: "CY"},
    {prefix: "+358", stateCode: "FI"},
    {prefix: "+358", stateCode: "AX"},
    {prefix: "+359", stateCode: "BG"},
    {prefix: "+370", stateCode: "LT"},
    {prefix: "+371", stateCode: "LV"},
    {prefix: "+372", stateCode: "EE"},
    {prefix: "+375", stateCode: "BY"},
    {prefix: "+376", stateCode: "AD"},
    {prefix: "+377", stateCode: "MC"},
    {prefix: "+378", stateCode: "SM"},
    {prefix: "+379", stateCode: "VA"},
    {prefix: "+380", stateCode: "UA"},
    {prefix: "+385", stateCode: "HR"},
    {prefix: "+386", stateCode: "SI"},
    {prefix: "+387", stateCode: "BA"},
    {prefix: "+389", stateCode: "MK"},
    {prefix: "+420", stateCode: "CZ"},
    {prefix: "+421", stateCode: "SK"},
    {prefix: "+423", stateCode: "LI"},
]